export default __webpack_public_path__ + "static/media/MMC-Lookup-Widget.8e384a65.png";